document.addEventListener('DOMContentLoaded', function () {
	'use strict'

	// Class constructor for Komodo Menu component.
	// Implements Komodo component design pattern
	//
	// @constructor
	// @param {HTMLElement} The element that will be upgraded to be Komodo Accordion.
	var KomodoMenu = function KomodoMenu(element) {
		this.element_ = element
		this.elementTrigger_ = document.querySelector(element.dataset.trigger)
		if (this.elementTrigger_) {
			// Toggle DropMenu
			this.elementTrigger_.addEventListener('click', this.toggleMenu.bind(this))
		}
	};
	window['KomodoMenu'] = KomodoMenu

	// Store strings for class names defined by this component that are used in
	// Javascript. This allows us to simply change it in one place should we decide
	// to modify at a later date.
	//
	// @enum {string}
	// @private
	KomodoMenu.prototype.cssClasses_ = {
		ACTIVE: 'is-visible',
		BOTTOM_LEFT: 'menu-down-left',
		BOTTOM_RIGHT: 'menu-down-right',
		TOP_LEFT: 'menu-up-left',
		TOP_RIGHT: 'menu-up-right',
	};

	// Toggle Menu.
	//
	// @public
	KomodoMenu.prototype.toggleMenu = function (event) {
		event.preventDefault()

		// Add a click listener to the document, to close the menu.
		var callback = function (evt) {
			// Check to see if the document is processing the same event that
			// displayed the menu in the first place. If so, do nothing.
			// Also check to see if the menu is in the process of closing itself, and
			// do nothing in that case.
			// Also check if the clicked element is a menu item
			// if so, do nothing.
			if (evt !== event && evt.target.parentNode !== this.element_) {
				document.removeEventListener('click', callback)
				this.element_.dispatchEvent(componentHandler.createEvent('closing.komodo.menu', null, false, true))
				this.element_.classList.remove(this.cssClasses_.ACTIVE)
				this.element_.dispatchEvent(componentHandler.createEvent('closed.komodo.menu', null, false, true))
			}
		}.bind(this)

		if (!this.element_.classList.contains(this.cssClasses_.ACTIVE)) {
			this.element_.dispatchEvent(componentHandler.createEvent('opening.komodo.menu', null, false, true))
			this.applyPosition_()
			this.element_.classList.add(this.cssClasses_.ACTIVE)
			this.element_.dispatchEvent(componentHandler.createEvent('open.komodo.menu', null, false, true))
			document.addEventListener('click', callback)
		}
	};
	KomodoMenu.prototype['toggleMenu'] = KomodoMenu.prototype.toggleMenu;

	// Apply Position
	//
	// Calculates the initial clip (for opening the menu) and applies it.
	// This allows us to animate from or to the correct point,
	// that is, the point it's aligned to in the "for" element.
	//
	// @param {number} height Height of the clip rectangle
	// @param {number} width Width of the clip rectangle
	// @private
	KomodoMenu.prototype.applyPosition_ = function () {
		if (this.element_.classList.contains(this.cssClasses_.TOP_LEFT)) {
			this.element_.style.bottom = this.elementTrigger_.getBoundingClientRect().height + "px";
		} else if (this.element_.classList.contains(this.cssClasses_.TOP_RIGHT)) {
			this.element_.style.bottom = this.elementTrigger_.getBoundingClientRect().height + "px";
		}
	};

	// The component registers itself. It can assume componentHandler is available
	// in the global scape.
	componentHandler.register({
		constructor: KomodoMenu,
		classAsString: 'KomodoMenu',
		cssClass: 'menu',
		widget: true
	})
})